<lx-selector-field-container
  [label]="label"
  [disabled]="disabled"
  [empty]="!selectedValue?.date"
  [selectorFieldHandler]="openSelectorClickHandler"
  data-qa="fixedDateSelector_field"
>
  <ng-content></ng-content>
</lx-selector-field-container>

<lx-side-panel [title]="title" [visible]="dialogVisible" (hiddenPanel)="hideDialog()" size="large" data-qa="fixedDateSelector_sidePanel">
  <lx-fixed-date-selector
    [fixedDates]="fixedDates"
    [selectedFixedDate]="selectedValue"
    (selectedFixedDateChange)="handleSelectedFixedDate($event)"
  ></lx-fixed-date-selector>
</lx-side-panel>
